import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CompanyHubAnnouncementBannerQuery: GraphQLTaggedNode = graphql`
	query CompanyHubAnnouncementBannerQuery($pageId: ID!, $keys: [String]!) {
		confluence {
			page(id: $pageId) {
				id
				properties(keys: $keys) {
					key
					value
					id
				}
			}
		}
	}
`;
